import { MODE } from '../../constants';
import SportsBook from '../SportsBook';

const PreMatchSportsBook = () => <SportsBook serviceId={MODE.PRE_MATCH} />;

export default PreMatchSportsBook;
